import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './Header.module.css';
import mark from '../../assets/images/asa-mark.png';
import { EASE_OUT } from '../motion';

export const CONTACT_EMAIL = 'samedakgul99@gmail.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Proje görüşmesi')}`;

const NAV_ITEMS = [
    { label: 'Projeler', to: '/projeler' },
    { label: 'Hizmetler', to: '/#hizmetler' },
    { label: 'Süreç', to: '/#surec' },
    { label: 'Hakkımda', to: '/hakkimda' },
];

// Ürün tanıtım sayfaları koyu temada; header orada beyaza döner.
export const DARK_ROUTES = ['/sonora-ai', '/funo', '/tattooai', '/meriastro', '/revoai', '/vloader'];
export const isDarkRoute = (pathname) => DARK_ROUTES.includes(pathname.replace(/\/$/, ''));

const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [hidden, setHidden] = useState(false);
    const location = useLocation();
    const dark = isDarkRoute(location.pathname);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname, location.hash]);

    useEffect(() => {
        let last = window.scrollY;
        const onScroll = () => {
            const y = window.scrollY;
            setScrolled(y > 40);
            setHidden(y > 200 && y > last);
            last = y;
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);

    const headerClass = [
        styles.header,
        dark ? styles.dark : '',
        scrolled && !open ? styles.scrolled : '',
        hidden && !open ? styles.hidden : '',
    ].join(' ');

    return (
        <>
            <header className={headerClass} id="header">
                <div className={`container-site ${styles.inner}`}>
                    <Link to="/" className={styles.logo} aria-label="Abdü Samed Akgül, ana sayfa">
                        <img src={mark} alt="" aria-hidden="true" className={styles.mark} />
                        asa
                    </Link>

                    <nav className={styles.nav} aria-label="Ana menü">
                        {NAV_ITEMS.map((item) => (
                            <Link key={item.to} to={item.to} className={styles.navLink}>
                                {item.label}
                            </Link>
                        ))}
                        <a href={CONTACT_MAILTO} className={`btn-pill ${dark ? 'btn-pill-light' : ''} ${styles.contact}`}>
                            İletişim
                        </a>
                    </nav>

                    <button
                        type="button"
                        className={`${styles.burger} ${open ? styles.open : ''}`}
                        onClick={() => setOpen((v) => !v)}
                        aria-expanded={open}
                        aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'}
                    >
                        <span className={`${styles.stripe} ${styles.stripeTop}`} />
                        <span className={`${styles.stripe} ${styles.stripeBottom}`} />
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        key="menu"
                        initial={{ clipPath: 'inset(0 0 100% 0)' }}
                        animate={{ clipPath: 'inset(0 0 0% 0)' }}
                        exit={{ clipPath: 'inset(0 0 100% 0)' }}
                        transition={{ duration: 0.7, ease: EASE_OUT }}
                        className={styles.menu}
                    >
                        <nav aria-label="Mobil menü">
                            {[...NAV_ITEMS, { label: 'İletişim', href: CONTACT_MAILTO }].map((item, index) => (
                                <motion.div
                                    key={item.label}
                                    initial={{ y: 40, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{ duration: 0.8, delay: 0.15 + index * 0.06, ease: EASE_OUT }}
                                >
                                    {item.href ? (
                                        <a href={item.href} className={styles.menuLink}>{item.label}</a>
                                    ) : (
                                        <Link to={item.to} className={styles.menuLink}>{item.label}</Link>
                                    )}
                                </motion.div>
                            ))}
                        </nav>
                        <p className={styles.menuFooter}>{CONTACT_EMAIL} · Ankara, Türkiye</p>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default Header;
